/* Fortune Food: quick add on collection cards (rows, tiles, dropdown, and round + on bundle photos)
   Listens in the CAPTURE phase so it runs before any theme/app handler that makes
   the whole product card clickable, then stops the event so the card link never fires. */
(function () {
  if (window.__ffQuickAdd) return;
  window.__ffQuickAdd = true;
  function FT(k, en, v) { var d = window.FF_I18N, s = d && typeof d[k] === 'string' && d[k] !== '' ? d[k] : en; return v ? s.replace(/\{(\w+)\}/g, function (m, n) { return v[n] != null ? String(v[n]) : m; }) : s; }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var TICK = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

  /* Keep quick-add controls above any full-card overlay */
  var st = document.createElement('style');
  st.textContent = '.ff-qa{position:relative;z-index:6}.ff-qa__row,.ff-qa__tile,.ff-qa__add,.ff-qa__select,.ff-qa__more,.ff-fab,.ff-fab__btn{position:relative;z-index:6;pointer-events:auto;touch-action:manipulation}.ff-fab{position:absolute}' +
    '.ff-edit-banner{margin:0 0 14px;padding:10px 12px;font-size:.9em;line-height:1.45;color:#7a4f00;background:#fff6e0;border:1px solid #f0d089;border-radius:6px}.ff-edit-banner a{text-decoration:underline;margin-left:4px}';
  (document.head || document.documentElement).appendChild(st);

  function updateCartDot() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble').forEach(function (el) {
          el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        });
      })
      .catch(function () {});
  }

  function showError(box, msg) {
    var err = box && box.querySelector('[data-ff-err]');
    if (!err) {
      if (box && box.dataset.ffFallback) window.location.href = box.dataset.ffFallback;
      return;
    }
    err.textContent = msg || FT('qa_fail', 'Could not add to cart. Please try again.');
    err.hidden = false;
    setTimeout(function () { err.hidden = true; }, 5000);
  }

  function stopAll(e) {
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('[data-ff-qa]')) {
        e.stopPropagation();
      }
    }, true);
  });

  document.addEventListener('click', function (e) {
    var box0 = e.target.closest && e.target.closest('[data-ff-qa]');
    if (!box0) return;

    if (e.target.closest('.ff-qa__more')) { e.stopPropagation(); return; }
    if (e.target.closest('[data-ff-select]')) { stopAll(e); return; }

    var add = e.target.closest('[data-ff-add]');
    stopAll(e);
    e.preventDefault();
    if (!add || add.disabled) return;

    var box = add.closest('[data-ff-qa]');
    var plus = add.querySelector('.ff-qa__plus');
    var original = plus ? plus.innerHTML : add.innerHTML;
    var qty = Math.max(1, parseInt(add.dataset.qty, 10) || 1);
    add.disabled = true;
    add.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(add.dataset.variant), quantity: qty }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message);
          return data;
        });
      })
      .then(function (data) {
        add.classList.remove('is-loading');
        add.classList.add('is-added');
        /* refresh + open the cart drawer, same as the product page Add to cart */
        var added = data && data.items && data.items[0];
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added } })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('ff:cart-changed')); } catch (e) {}
        if (plus) { plus.innerHTML = TICK; } else { add.innerHTML = FT('qa_added', '✓ Added to cart'); }
        updateCartDot();
        setTimeout(function () {
          add.classList.remove('is-added');
          if (plus) { plus.innerHTML = original; } else { add.innerHTML = original; }
          add.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        add.classList.remove('is-loading');
        if (!plus) add.innerHTML = original;
        add.disabled = false;
        showError(box, err && err.message);
      });
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-ff-select]');
    if (!sel) return;
    var box = sel.closest('[data-ff-qa]');
    var opt = sel.options[sel.selectedIndex];
    box.querySelector('.ff-qa__add').dataset.variant = opt.value;
    box.querySelector('[data-ff-price]').textContent = opt.dataset.price;
  }, true);

  /* ------------------------------------------------------------------
     Fortune Food: edit a cart item.
     Cart "Edit" link opens the product page with ?variant=...&ff_edit=<line key>&ff_qty=<qty>.
     On that page the add button becomes "Update cart": it adds the newly chosen variant
     (same quantity), removes the old cart line, then returns to the cart.
  ------------------------------------------------------------------ */
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (err) { params = null; }
  var editKey = params && params.get('ff_edit');
  if (!editKey) return;

  var editQty = Math.max(1, parseInt(params.get('ff_qty'), 10) || 1);
  var oldVariant = String(editKey).split(':')[0];
  var cartUrl = root + 'cart';

  function productForm() {
    return document.querySelector('.product-single__form, form[action*="/cart/add"]');
  }

  function relabel(btn) {
    if (!btn || btn.disabled) return;
    var span = btn.querySelector('[data-add-to-cart-text]') || btn;
    if (span.textContent.trim() !== FT('qa_update', 'Update cart')) span.textContent = FT('qa_update', 'Update cart');
  }

  function initEdit() {
    var form = productForm();
    if (!form) return;

    var banner = document.createElement('div');
    banner.className = 'ff-edit-banner';
    banner.innerHTML = FT('qa_editing', '<strong>You’re editing an item in your cart.</strong> Change your options, then tap <strong>Update cart</strong>.') + '<a href="' + cartUrl + '">' + FT('qa_cancel', 'Cancel') + '</a>';
    form.parentNode.insertBefore(banner, form);

    var btn = form.querySelector('[name="add"], button[type="submit"]');
    relabel(btn);
    if (btn && window.MutationObserver) {
      new MutationObserver(function () { relabel(btn); })
        .observe(btn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    }
  }

  function handleUpdate(e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('[data-ff-qa]')) return;
    if (e.type === 'click' && !e.target.closest('[name="add"], button[type="submit"]')) return;
    e.preventDefault();
    stopAll(e);
    if (form.__ffBusy) return;

    var fd = new FormData(form);
    var newId = String(fd.get('id') || '');
    if (!newId || newId === oldVariant) { window.location.href = cartUrl; return; }

    form.__ffBusy = true;
    fd.set('quantity', editQty);

    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message);
        });
      })
      .then(function () {
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: editKey, quantity: 0 })
        });
      })
      .then(function () { window.location.href = cartUrl; })
      .catch(function (err) {
        form.__ffBusy = false;
        window.alert((err && err.message) || FT('qa_update_fail', 'Could not update your cart. Please try again.'));
      });
  }

  document.addEventListener('click', handleUpdate, true);
  document.addEventListener('submit', handleUpdate, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEdit);
  } else {
    initEdit();
  }
})();
